<script lang="ts">
    import ContactForm from "$components/Elements/ContactForm.svelte";
    import MeetingForm from "$components/Elements/MeetingForm.svelte";
    import EvaluationForm from "$components/Elements/EvaluationForm.svelte";

    export let section: Section;
    export let index: number;

</script>

{#if section.type === 'contact-form'}
    <ContactForm {section} {index}/>
{/if}

{#if section.type === 'meeting-form'}
    <MeetingForm {section} {index}/>
{/if}

{#if section.type === 'evaluation-form'}
    <EvaluationForm {section} {index}/>
{/if}
